import React, { Component } from 'react';
import { Layout, Button, Row, Col, Tabs, Icon, Divider } from 'antd';
import style from './Login.css';
import logo from '../login/200x35蒙牛.png';
import ChangePassword from './ChangePassword';

const { Header, Footer, Content } = Layout;
export default class index extends Component {
  render() {
    return (
      <Layout className={style.loginLayout}>
          <Header className={style.loginHeader}>
              <div className={style.loginTitle}>
                  <img className={style.loginTitleImg} src={logo} alt="" />
              </div>

              <div onClick={() => { tool.popSingleUI('/') }} className={style.toLogin}>
                返回登录
              </div>
          </Header>
          <Content className={style.loginContent}>
            {/* <h2 className={style.formTitle} style={{color: '#00b34f'}}>用户注册</h2>
            <Divider className={style.Divider1} /> */}
            <ChangePassword formstate="asdasd"></ChangePassword>
          </Content>

      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./apps/pages/ChangePassword/index.js